/* eslint-disable */

const getters = {
  listInventory: state => state.listInventory || [],
};

export default getters;
